export default "__VITE_ASSET__BD0poCE5__"